// extracted by mini-css-extract-plugin
module.exports = {"SectionBanner":"SectionBanner_SectionBanner_1lTSA","navigation":"SectionBanner_navigation_19BPr"};